import { AxiosResponse } from "axios";
import { axiosHttpClient } from "../../store/GlobalContext";
import { ReleaseNoteModel } from "../../types/ReleaseNoteModel";

export const addReleaseNote = (releaseNoteModel: ReleaseNoteModel): Promise<AxiosResponse> => {
    if (releaseNoteModel.title?.length === 0) {
        releaseNoteModel.title = undefined;
    }
    
    return axiosHttpClient.post("v1/releasenotes", releaseNoteModel) as Promise<AxiosResponse>;
};

export const getExistingReleaseNotes = (): Promise<AxiosResponse<ReleaseNoteModel[]>> => {
    return axiosHttpClient.get("v1/releasenotes?page=1&pageSize=100&onlyPast=false")
};

export const deleteReleaseNote = (releaseNoteId: number): Promise<AxiosResponse> => {
    return axiosHttpClient.delete(`v1/releasenotes/${releaseNoteId}`, {})
};

export const updateReleaseNote = (id : number, releaseNoteModel : ReleaseNoteModel): Promise<AxiosResponse> => {
    return axiosHttpClient.put(`v1/releasenotes/${releaseNoteModel.id}`, releaseNoteModel)
};